"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemTypeCell = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const ItemTypeCell = (props) => {
    function handleChange(value) {
        const itemClone = (0, cloneDeep_1.default)(props.item);
        itemClone.type = value;
        // Make sure we're still using the matching config.
        if (!props.isResource) {
            itemClone.updateConfigItem(props.booking);
        }
        props.onItemChange(itemClone);
    }
    if (props.isResource ||
        !props.item.customized ||
        props.allTypes.length === 0) {
        // Either a resource or a locked (not customized) item or no selection of types.
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, props.item.type)));
    }
    else {
        // Customized item. We show a dropdown.
        let typeOptions = props.allTypes;
        // If config does not contain the type, we include it in the dropdown.
        if (!typeOptions.includes(props.item.type)) {
            typeOptions = [props.item.type, ...typeOptions];
        }
        return (react_1.default.createElement("select", { className: "", value: props.item.type, onChange: (e) => handleChange(e.target.value), disabled: !props.editable }, typeOptions.map((type) => (react_1.default.createElement("option", { key: type }, type)))));
    }
};
exports.ItemTypeCell = ItemTypeCell;
